export default __webpack_public_path__ + "static/media/logo.93bf61c6.png";